import { Component, Element, h } from '@stencil/core';

@Component({
  tag: 'aui-service-notification',
  shadow: false,
})
export class AuiServiceNotification {
  @Element() element: HTMLAuiServiceNotificationElement;

  render() {
    return this.element.textContent ? (
      <s-banner noDismiss={true}>
        <slot></slot>
      </s-banner>
    ) : null;
  }
}
